/* eslint-disable react/prop-types */
import { Link } from "react-router-dom";
import { useContext } from "react";
import {
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Button,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import { Context } from "../../hooks/useAuthContext";
import "./styles.css";

function SideMenu({ isOpen, onClose }) {
  const { logout, userData, isEmailRodrigo } = useContext(Context);

  function handleLogout() {
    logout();
  }

  return (
    <Offcanvas isOpen={isOpen} toggle={onClose} direction="end">
      <OffcanvasHeader toggle={onClose}>Menu</OffcanvasHeader>
      <div className="dadosSideBar">
        <span className="nomeUser">Olá, {userData?.nome.split(" ", 1)}</span>
        <span className="emailUser">{userData?.email}</span>
      </div>
      <OffcanvasBody>
        <ListGroup flush>
          <ListGroupItem tag={Link} to="/atualizar-dados" action>
            Atualizar dados
          </ListGroupItem>
          {userData.afiliadoConfig && userData.tipoConta !== 'afiliado' && 
            <ListGroupItem tag={Link} to="/meu-afiliado" action>
              Dash Afiliado
            </ListGroupItem>
          }
          <ListGroupItem tag={Link} to="/minhas-notas-fiscais" action>
            Minhas notas fiscais
          </ListGroupItem>
          <ListGroupItem tag={Link} to="/abrir-chamado" action>
            Abrir chamado
          </ListGroupItem>
          <ListGroupItem tag={Link} to="/duvidas" action>
            Dúvidas
          </ListGroupItem>

          {userData?.email === isEmailRodrigo && (
            <ListGroupItem tag={Link} to="/receitas-usuarios" action>
              Receitas por usuários
            </ListGroupItem>
          )}
          {userData?.tipoConta === "usuario" ? (
            <ListGroupItem tag={Link} to="/contrato-cortador" action>
              Termos de uso
            </ListGroupItem>
          ) : (
            <ListGroupItem tag={Link} to="/contrato-influenciador" action>
              Termos de uso
            </ListGroupItem>
          )}
        </ListGroup>
        <div className="mt-4">
          <Button color="danger" onClick={handleLogout} block>
            Desconectar da sua conta
          </Button>
        </div>
      </OffcanvasBody>
    </Offcanvas>
  );
}

export default SideMenu;
